export default {
	id: 'SIMPLE_WORKBOOK_BUNDLE_35',
	providers: {
		paltaMap: {
			USD: 'simple_workbook_bundle_35_usd',
			EUR: 'simple_workbook_bundle_35_eur',
			TRY: 'simple_workbook_bundle_1899_try',
			AUD: 'simple_workbook_bundle_39_aud',
			GBP: 'simple_workbook_bundle_35_gbp',
			CAD: 'simple_workbook_bundle_39_cad',
			BRL: 'simple_workbook_bundle_119_brl',
			MXN: 'simple_workbook_bundle_599_mxn',
			DKK: 'simple_workbook_bundle_299_dkk',
			NOK: 'simple_workbook_bundle_349_nok',
			SEK: 'simple_workbook_bundle_359_sek',
		},
		primer: 'prd_VXdByxPtAYZQ',
	},
	otp: {
		priceMap: {
			USD: 35,
			EUR: 35,
			TRY: 1899,
			AUD: 39,
			GBP: 35,
			CAD: 39,
			BRL: 119,
			MXN: 599,
			DKK: 299,
			NOK: 349,
			SEK: 359,
		},
	},
}
